import {ActionPropsHolder} from './actionProps';

export type onCancel = () => void;

export function cancel(holder: ActionPropsHolder, onCancel?: onCancel) {
  if (onCancel) {
    onCancel();
  }
}
